import { BuyerInfo, EIdaPerson, ENocLookUpKeys, ENocMLookUp, ENocMollakData, EnocMollakDocuments, Mode, OwnerType, TabuPerson } from "./entities";
import { loadLookUp, validateFromDNRD } from "./api";
import moment from "moment";
import { Component } from "react";
import { checkNonEmpty } from "@my-dld/components/Form/FormField";
import { showMessage } from "@my-dld/utils/UIUtils";
import { DateUtil, LocaleUtil, StringUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";
import { checkValidationErrorWithMessage } from "../greenlistapi/api";
import * as ENocMApi from "../enocapi/api";
import { ErrorContainer } from "@eres/forms";
import { checkExceedLimit } from "@my-dld/screens/Register/utils";

function eNocMLookUpToStateKey( lookup: ENocMLookUp ): string {
	if ( ENocLookUpKeys[ lookup ] ) {
		return ENocLookUpKeys[ lookup ];

	}
	return lookup as string;
}

export function populateENocMLookup( lookup: ENocMLookUp, stateHolder?: any, callback?: ( values?: any ) => void ) {
	loadLookUp( lookup ).then( ( lkpData: any ) => {
		const stateKey = eNocMLookUpToStateKey( lookup );
		if ( stateHolder ) {
			stateHolder.setState( {
				[ stateKey ]: lkpData.items,
			} );
		}
		if ( callback ) {
			callback( lkpData.items );
		}
	} ).catch( ( reason: any ) => {
			if ( callback ) {
				callback( undefined );
			}
		},
	);
}

export function getPreviousDate( from?: Date, numOfDays?: number ): Date {
	let currentDate = moment( from ? from : new Date() );
	return currentDate.add( numOfDays ? -( numOfDays ) : -1, "days" ).toDate();
}

export function getAfterDate( from?: Date, numOfDays?: number ): Date {
	let currentDate = moment( from ? from : new Date() );
	return currentDate.add( numOfDays ? numOfDays : 1, "days" ).toDate();
}

export function validatePersonForm( state: BuyerInfo, handler: Component<any, any>, isCompany: boolean ): boolean {
	let isValid: boolean = true;
	// let errorViews: { [k: string]: string } = {};
	let errorViews: ErrorContainer = {};
	let errorMsg: string[] = [];
	if ( isCompany ) {
		isValid = checkNonEmpty( state, "ManagerNameAr", errorViews ) && isValid && isCompany!;
		isValid = checkNonEmpty( state, "ManagerNameEn", errorViews ) && isValid && isCompany!;
	} else {
		isValid = checkNonEmpty( state, "PersonNameAr", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "PersonNameEn", errorViews ) && isValid;
	}
	if ( state.isUAEResident ) {
		isValid = checkNonEmpty( state, "emiratesID", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "emiratesIdExpiry", errorViews ) && isValid;
		if ( state.emiratesIdExpiry ) {
			let endDate = DateUtil.parseDate( state.emiratesIdExpiry ? state.emiratesIdExpiry : "", "YYYY-MM-DDThh:mm:ss" );
			const m = checkExceedLimit( endDate );
			if ( !m ) {
				errorViews.emiratesIdExpiry = Strings.emirates_id_expired;
			}
			isValid = m;

		}
	}
	isValid = checkNonEmpty( state, "passportNumber", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "passportIssuedBy", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "startDate", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "endDate", errorViews ) && isValid;
	if ( state.endDate ) {
		let endDate = DateUtil.parseDate( state.endDate ? state.endDate : "", "YYYY-MM-DDThh:mm:ss" );
		const m = checkExceedLimit( endDate );
		if ( !m ) {
			errorViews.endDate = Strings.invalid_data;
		}
		isValid = m;

	}
	isValid = checkNonEmpty( state, "birthDate", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "birthPlace", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "nationality", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "mobile", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "email", errorViews ) && isValid;
	if ( isValid ) {
		isValid = validateEmail( errorViews, errorMsg, state, "email" ) && isValid;
	}
	if ( isValid ) {
		isValid = checkNonEmpty( state, "gender", errorViews ) && isValid;
		if ( !isValid ) errorMsg.push( Strings.please_select + " " + Strings.gender );
	}
	handler.setState( { errorContainer: errorViews } );
	if ( errorMsg.length > 0 ) {
		showMessage( errorMsg.join( "\n" ) );
	}
	return isValid;
}

export function validateCompanyForm( state: BuyerInfo, handler: Component<any, any> ): boolean {
	let isValid: boolean = true;
	let errorViews: string[] = [];
	isValid = checkNonEmpty( state, "licenseAuthority", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "tradeLicenseNumber", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "CompanyNameAr", errorViews ) && isValid;
	isValid = checkNonEmpty( state, "CompanyNameEn", errorViews ) && isValid;
	handler.setState( { errorViews: errorViews } );
	return isValid;
}

export function validateDocuments( state: BuyerInfo ): boolean {
	let isValid: boolean = true;
	state.documents?.map( value => {
		if ( !value.docs ) {
			isValid = false;
		}
		if ( value.docs && !value.docs.fileName ) {
			isValid = false;
		}
	} );
	return isValid;
}

export function validateMobile( errorViews: any, errorMsg: string[],
                                state: any,
                                key: string = "Mobile" ): boolean {
	let isValid = true;
	let mob = StringUtil.normaliseMobileNumber( state[ key ] );
	if ( mob == undefined || mob.length < 12 ) {
		isValid = false;
		errorViews.push( key );
		errorMsg.push( Strings.invalid_mobile );
	}
	return isValid;
}

export function validateEmail( errorViews: any, errorMsg: string[],
                               state: any,
                               key: string = "Email" ): boolean {
	let isValid = true;
	let email = state[ key ];
	if ( !StringUtil.isEmailAddress( email ) ) {
		isValid = false;
		errorViews.push( key );
		errorMsg.push( Strings.invalid_email );
	}
	return isValid;
}

export function updateDataFromDNRD( eid: string, isCompany: boolean ): Promise<BuyerInfo> {
	let apiHandler = ( response: any ) => {
		let buyer: BuyerInfo = {
			emiratesID: eid,
		};
		let result = response.Response;
		if ( result && result.EmiratesId ) {
			if ( isCompany ) {
				buyer.ManagerNameEn = result.NameEn.toString().capitalize;
				buyer.ManagerNameAr = result.NameAr.toString().capitalize;
			} else {
				buyer.PersonNameEn = result.NameEn;
				buyer.PersonNameAr = result.NameAr;
			}
			buyer.passportNumber = result.Passport;
			buyer.mobile = result.Mobile;
			buyer.endDate = result.PassportExpiryDate;
			buyer.emiratesIdExpiry = result.EIDExpiryDate;
			buyer.passportNumber = result.Passport;
			buyer.mobile = result.Mobile;
			buyer.endDate = result.PassportExpiryDate;
			buyer.birthDate = result.BirthDate;
			buyer.genderId = result.GenderId; // 1 - male and 2 - female
			// if (result.NationalityEntity) {
			// 	const country: ENocMLookupData = {
			// 		identity: result.NationalityEntity?.Identity,
			// 		nameEn: result.NationalityEntity?.NameEn,
			// 		nameAr: result.NationalityEntity?.NameAr,
			// 	};
			// 	buyer.nationality = country;
			// }
			return Promise.resolve( buyer );
		} else {
			return Promise.resolve( buyer );
		}
	};
	let apiExHandler = ( reason: any ) => {
		const buyer: BuyerInfo = {
			emiratesID: eid,
		};
		return Promise.resolve( buyer );
	};
	return validateFromDNRD( 1, eid ).then( apiHandler ).catch( apiExHandler );
}

export function uploadDocs( reqDocs: EnocMollakDocuments[] ): Promise<any> {
	let uploadTasks: Promise<any>[] = [];
	for ( let reqDoc of reqDocs ) {
		if ( reqDoc.docs != undefined ) {
			let doc = reqDoc.docs;
			if ( reqDoc.serverId == undefined ) {
				uploadTasks.push( ENocMApi.uploadDocument( doc.localFile!, reqDoc.documentType!, reqDoc.identity! ).then( response => {
					return checkValidationErrorWithMessage( response );
				} ).then( ( response: any ) => {
					if ( response.responseCode === "Success" && response.response ) {
						if ( reqDoc.serverId === undefined ) {
							reqDoc.serverId = response.response.id;
							reqDoc.url = response.response.url;
							reqDoc.id = response.response.id;
							reqDoc = updateModule( reqDoc );
							// reqDoc.docs = undefined;
							// reqDoc.serverId = undefined;
							// reqDoc.documentType = undefined;
						}
						return Promise.resolve( reqDoc );
					}
					return Promise.resolve( reqDoc );
				} ).catch( ( reason: any ) => {
					return Promise.reject( "Document upload failed" );
				} ) );
			} else {
				reqDoc = updateModule( reqDoc );
				uploadTasks.push( Promise.resolve( reqDoc ) );
			}
		}
	}
	return Promise.all( uploadTasks );
}

function updateModule( reqDoc: EnocMollakDocuments ) {
	reqDoc.documentType = undefined;
	reqDoc.serverId = undefined;
	// uncomment below if using same request
	reqDoc.docs = undefined;
	reqDoc.documentTypeId = undefined;
	reqDoc.documentCategory = undefined;
	reqDoc.identity = undefined;
	reqDoc.nameEn = undefined;
	reqDoc.nameAr = undefined;
	reqDoc.name = undefined;
	return reqDoc;
}

export function GetFilenameFromServerUrl( url: string ) {
	if ( url ) {
		let m = url.toString().match( /.*\/(.+?)\./ );
		if ( m && m.length > 1 ) {
			return m[ 1 ];
		}
	}
	return "";
}

export function normalizeENocRequest( resp: ENocMollakData, mode: Mode ): ENocMollakData {
	let eNOCModel: ENocMollakData = resp;
	eNOCModel.mode = mode;
	eNOCModel.mollakPropertyId = Number( eNOCModel.property?.mollakPropertyId );
	let requestInfo = eNOCModel.requestInfo;
	let owner = eNOCModel.requestInfo?.owner;
	if ( requestInfo && owner ) {
		owner.identity = eNOCModel.owners && eNOCModel.owners.length > 0 ? Number( eNOCModel.owners[ 0 ].ownerNumber ) : 0;
		requestInfo.owner = owner;
	}
	eNOCModel.requestInfo = requestInfo;
	if ( mode !== "create" ) {
		eNOCModel.totalArea = eNOCModel.property?.applicableArea;
	}
	eNOCModel.buyerInfo?.map( ( value: BuyerInfo ) => {
		let buyer: BuyerInfo = value;
		buyer.mode = mode;
		const isCompany = value.ownershipType?.identity === OwnerType.COMPANY;
		buyer.startDate = value.passportValidity?.startDate!;
		buyer.endDate = value.passportValidity?.endDate!;
		buyer.email = value.contact?.email;
		buyer.mobile = value.contact?.mobile;
		buyer.CompanyNameEn = value.companyName?.englishName!;
		buyer.CompanyNameAr = value.companyName?.arabicName!;
		buyer.genderId = ( value.gender && value.gender?.identity ) ? value.gender?.identity : undefined;
		buyer.birthPlace = value.birthPlace;
		if ( isCompany ) {
			buyer.ManagerNameEn = value.managerName?.englishName!;
			buyer.ManagerNameAr = value.managerName?.arabicName!;
		} else {
			buyer.PersonNameEn = value.managerName?.englishName!;
			buyer.PersonNameAr = value.managerName?.arabicName!;
			buyer.licenseAuthority = undefined;
			buyer.tradeLicenseNumber = undefined;
		}
		buyer.documents?.map( value1 => {
			let d = value1;
			d.identity = value1.documentTypeId;
			d.serverId = value1.id + "";
			d.name = value1.documentCategory;
			d.nameEn = value1.documentCategory?.nameEn;
			d.nameAr = value1.documentCategory?.nameAr;
			d.documentType = isCompany ? "COMPANYBUYER" : "EXPAT";
			d.docs = {
				identity: value1.documentTypeId,
				fileUrl: value1.url!,
				fileName: GetFilenameFromServerUrl( value1.url! ),
			};
			return d;
		} );
		return buyer;
	} );
	eNOCModel.owners = undefined;
	return eNOCModel;
}

export function normalizeEIdaPersonToMollak( person: EIdaPerson, mollakBuyer?: BuyerInfo ): BuyerInfo {
	let buyer: BuyerInfo = {};
	if ( mollakBuyer ) {
		buyer = mollakBuyer;
	}
	buyer.nationality = person.nationalityEntity;
	const NameEn = toTitleCase( person.nameEn );
	const NameAr = person.nameAr;
	if ( buyer.isCompany ) {
		buyer.ManagerNameEn = NameEn;
		buyer.ManagerNameAr = NameAr;
	} else {
		buyer.PersonNameEn = NameEn;
		buyer.PersonNameAr = NameAr;
	}
	buyer.managerName = {
		englishName: NameEn,
		arabicName: NameAr,
	};
	if ( person.genderId ) {
		buyer.genderId = person.genderId;
	}
	buyer.birthDate = validateBuyerDate( person.birthDate );
	buyer.emiratesID = person.emiratesId;
	buyer.emiratesIdExpiry = validateBuyerDate( person.emiratesIdExpiryDate );
	buyer.passportNumber = person.passport;
	buyer.startDate = validateBuyerDate( person.passportIssueDate );
	buyer.endDate = validateBuyerDate( person.passportExpiryDate );
	buyer.passportValidity = {
		startDate: buyer.startDate,
		endDate: buyer.endDate,
	};
	buyer.mobile = person.mobile;
	buyer.email = person.email;
	buyer.birthPlace = person.placeOfBirth;
	buyer.passportIssuedBy = person.passportIssuePlace;

	return buyer;
}

export function normalizeTabuPersonToMollak( person: TabuPerson, mollakBuyer?: BuyerInfo ): BuyerInfo {
	let buyer: BuyerInfo = {};
	if ( mollakBuyer ) {
		buyer = mollakBuyer;
	}
	buyer.participantId = Number( person.ParticipantId );
	const NameEn = toTitleCase( person.PersonNameEn );
	const NameAr = person.PersonNameAr;
	if ( buyer.isCompany ) {
		buyer.ManagerNameEn = NameEn;
		buyer.ManagerNameAr = NameAr;
	} else {
		buyer.PersonNameEn = NameEn;
		buyer.PersonNameAr = NameAr;
	}
	buyer.managerName = {
		englishName: NameEn,
		arabicName: NameAr,
	};
	buyer.email = person.Email;
	buyer.mobile = StringUtil.normaliseMobileNumber( person.Mobile );
	buyer.emiratesIdExpiry = validateBuyerDate( person.EIDExpiryDate );
	buyer.birthDate = validateBuyerDate( person.BirthDate );
	buyer.birthPlace = LocaleUtil.getLocalValue( { en: person.BirthPlaceEn, ar: person.BirthPlaceAr } );
	if ( person.CountryId ) {
		buyer.nationality = {
			identity: person.CountryId,
			nameAr: person.CountryArabicName,
			nameEn: person.CountryEnglishName,
		};
	}
	buyer.passportNumber = person.PassportNumber;
	buyer.passportIssuedBy = LocaleUtil.getLocalValue( { en: person.PassportIssuePlaceEnglish, ar: person.PassportIssuePlaceArabic } );
	buyer.startDate = validateBuyerDate( person.PassportIssueDate );
	buyer.endDate = validateBuyerDate( person.PassportExpiryDate );
	if ( person.GenderId ) {
		buyer.genderId = ( person.GenderId === 0 ) ? 1 : 2;
	}
	return buyer;
}

export function toTitleCase( str: string ) {
	if ( str ) {
		return str.replace(
			/\w\S*/g,
			function ( txt ) {
				return txt.charAt( 0 ).toUpperCase() + txt.substr( 1 ).toLowerCase();
			},
		);
	}
	return undefined;
}

function validateBuyerDate( tempDate: string ) {
	if ( tempDate ) {
		let sd = moment( tempDate );
		if ( sd.format( "MM-DD-YYYY" ) === "01-01-0001" ) {
			return undefined;
		}
	}
	return tempDate;
}
